var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronPrimary = function SvgChevronPrimary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2 2 4 4-4 4",
    stroke: "#1780EA",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })));
};
export default SvgChevronPrimary;